import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Box, Tooltip } from '@mui/material';

import { fetchDefaultFeedbackMessages } from '../../../modules/reports/thunks';

const SubmitFeedbackButton = ({
  setIsOpenFeedbackModal,
  houseRef,
  setIsButtonClickType,
  setLoadingFeedbackModalData,
  selectedLotsForDisputes
}) => {
  const dispatch = useDispatch();
  const handleLeaveFeedbackOnSelected = () => {
    setLoadingFeedbackModalData(true);
    setIsOpenFeedbackModal(true);
    dispatch(fetchDefaultFeedbackMessages(houseRef, setLoadingFeedbackModalData, true));
    setIsButtonClickType('button');
  };

  const isDisabled = !selectedLotsForDisputes.length;

  return (
    <Box>
      <Tooltip
        title={isDisabled ? 'Feedback cannot be left for floor bidders' : ''}
        placement="top"
        arrow
      >
        <span>
          <Button
            variant="contained"
            color="primary"
            className="cursor-not-allowed placeBidbutton"
            disabled={isDisabled}
            onClick={handleLeaveFeedbackOnSelected}
          >
            <span>Leave Feedback on Selected {selectedLotsForDisputes.length > 0 && `(${selectedLotsForDisputes.length})`}</span>
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default SubmitFeedbackButton;
